import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { GenericSearchSelectComponent } from './generic-search-select.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, NgxMatSelectSearchModule],
  exports: [GenericSearchSelectComponent],
  declarations: [GenericSearchSelectComponent]
})
export class GenericSearchSelectModule {}
